import * as React from "react";
import * as classNames from "classNames";
import { Alert } from "../../../Shared/Components/Alert";
import { AlertType } from "../../../Shared/Entities/Constants/AlertConstants";
import { AllocationTableItem } from "../Store/SelectedInvesmentStoreStatic";
import { TableHeader } from "../../Table/Components/TableHeader";
import { allocationTableColConfig } from "./Shared/AllocationTableHelper";
import { groupBy } from "../../../../react-core/Utils/Arrays";
import { TableRow } from "../../Table/Components/TableRow";
import { getValueByKey, setValueByKey } from "../../Table/Utils/TableUtils";
import { ProcessType } from "../Resource/Content";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { InvestmentDetailsPopupModal } from "../../../Dashboard/Components/Clients/Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { Investment } from "../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentSelectionAction } from "../Action/InvestmentSelectionAction";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";
import { getQueryParameters } from "../../Wizards/Entities/QueryParametersHelper";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { Action } from "../../../Dashboard/Actions/Action";
import { Objects } from "../../../../react-core/Utils/Objects";
import { ProductType } from "../../../../Wrap/Constants/Enums/Domain/ProductType";
import { DepositProduct } from "../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { DepositProductsQuery } from "../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { ResultPageModel } from "../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { DepositDetailsPopupModal } from "../../../Dashboard/Components/Clients/Common/DepositDetailsPopUp/DepositDetailsPopupModal";
import { CheckboxEditor } from "../../../../react-core/Html/CheckboxEditor";
import { SelectedInvestmentStore } from "../Store/Variable";
import { Money } from "../../../../Wrap/Core/DataTypes/Money";

export interface IAllocationTableProps extends IProcessComponentProps {
    onChange: (v, id) => void;
    data: AllocationTableItem[];
    treasuredAssetsProductIds: number[];
    onChangeTreasuredAssets?: (productId: number, value: boolean) => void;
    onToggle: (isToggle, index, rowData) => void;
    isUnderlying?: boolean;
    isAssetClass: boolean;
    type: ProcessType;
    modelData: any;
    product: SubAccountType;
    readonly?: boolean;
    cssWrapper?: string;
    accountServiceProposition: ServiceProposition;
    paymentAmount?: Money;
}

export interface IAllocationTableState {
    isShowDetailModal: boolean;
    selectedInvestment: Investment;
    originTreasureAssets: number[];
    cashProducts: Record<number, DepositProduct>;
    isCashProductsLoading: boolean;
}

export class AllocationTable extends ProcessComponent<IAllocationTableProps, IAllocationTableState> {
    constructor(props: IAllocationTableProps) {
        super(props);
        this.state =
            {
                isShowDetailModal: false,
                selectedInvestment: null,
                originTreasureAssets: [],
                cashProducts: {},
                isCashProductsLoading: false
            };
        this.col = allocationTableColConfig(
            props,
            this.state,
            (investment) => this.onInvestmentSelected(investment))
        .filter(
            (ele) => ele != null)
        ;
        this.isSum100 =
            Object.values(this.getTotalRow(this.col, props.data)).filter(
                (ele) => ele !== "100%" && ele !== "Total" && ele !== "" && ele !== "0%"
            ).length == 0 && Object.values(this.getTotalRow(this.col, props.data)).filter((ele) => ele == "100%").length >= 1;

        this.subscribeToStore(SelectedInvestmentStore, () => this.onStoreChange());
    }

    componentDidMount(): void {
        super.componentDidMount();
        if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
            Action.getSubAccountTreasuredAssets(getQueryParameters()["subaccounthierarchyid"], (res) => {
                this.setState({ originTreasureAssets: res });
            });
        }

        this.fetchCashProductDetails(this.props.data);
    }

    onStoreChange(): void
    {
        this.fetchCashProductDetails(this.props.data);
    }

    private isSum100: boolean;
    private allocationLeft: number;

    private col;
    private allocationLeftDic: { [key: string]: number } = {};
    private indexAlertDic: { [key: string]: number } = {};

    private onInvestmentSelected(investment) {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            this.setState({ selectedInvestment: d, isShowDetailModal: true });
        });
    }

    isValid() {
        if (!this.isSum100)
            {this.props.showErrorMsgPopUp([
                "Please check that all investments have been allocated and the total allocation is 100%.",
            ]);}
        return super.isValid() && this.isSum100;
    }

    fetchCashProductDetails(investmentList: AllocationTableItem[]): void
    {
        this.setState({ isCashProductsLoading: true });

        const cashProductIds: number[] = Array.from(
            new Set(investmentList
                .filter(row => row.Instrument.Type === ProductType.CashProduct)
                .map(row => row.Instrument.ProductId))
        );

        if (cashProductIds.length === 0)
        {
            return;
        }

        const query: DepositProductsQuery =
            {
                ProductIds: cashProductIds,
                ServiceProposition: this.props.accountServiceProposition,
                ResultsPerPage: cashProductIds.length
            };

        InvestmentSelectionAction.searchDepositProducts(
            query,
            getQueryParameters()["hierarchyid"],
            (data: ResultPageModel<DepositProduct>) =>
            {
                const cashProducts: Record<number, DepositProduct> = data.Results
                    .reduce<Record<number, DepositProduct>>(
                        (acc, product) =>
                        {
                            acc[product.ProductId] = product;
                            return acc;
                        },
                        {})

                this.setState(
                    {
                        cashProducts: cashProducts,
                        isCashProductsLoading: false
                    });
            },
            (err) =>
            {
                console.error("Failed to fetch deposit products:", err);
            });
    }

    private getTotal = (group, key) => {
        let total = group.data.reduce((total, curr) => {
            return total + (getValueByKey(curr, key) || 0);
        }, 0);
        total = Number(total.toFixed(2)) == 100 ? 100 : total;

        this.allocationLeft = 100 - total;
        this.allocationLeftDic[key] = this.allocationLeft;

        if (total > 100) {
            let totalPercentage = 0;
            for (let i = 0; i < group.data.length; i++) {
                totalPercentage = totalPercentage + (getValueByKey(group.data[i], key) || 0);
                if (totalPercentage > 100) {
                    this.indexAlertDic[key] = i;
                    break;
                }
            }
        }
        return total + "%";
    };

    private getSubTotalRow = (group, col) => {
        let totalRow = {};
        col.forEach((ele, index) => {
            if (index === 0) {
                totalRow = setValueByKey(totalRow, ele.title, group.classCode);
            } else if (ele.title.toLowerCase() === "protect from auto-disinvestment") {
                totalRow = setValueByKey(totalRow, ele.title, "");
            } else if (index == col.length - 1) {
                totalRow = setValueByKey(totalRow, ele.title, "");
            } else {
                totalRow = setValueByKey(totalRow, ele.title, this.getTotal(group, ele.key));
            }
        });
        return totalRow;
    };

    private getTotalRow = (col, data) => {
        let totalRow = {};
        col.forEach((ele, index) => {
            if (index == 0) {
                totalRow = setValueByKey(totalRow, ele.title, "Total");
            } else if (ele.title.toLowerCase() === "protect from auto-disinvestment") {
                totalRow = setValueByKey(totalRow, ele.title, "");
            } else if (index == col.length - 1 && !this.props.readonly) {
                totalRow = setValueByKey(totalRow, ele.title, "");
            } else {
                totalRow = setValueByKey(totalRow, ele.title, this.getTotal({ data: data }, ele.key));
            }
        });
        this.isSum100 =
            Object.values(totalRow).filter((ele) => ele !== "100%" && ele !== "Total" && ele !== "" && ele !== "0%").length == 0
            && Object.values(totalRow).filter((ele) => ele == "100%").length >= 1;
        return totalRow;
    };

    private renderTableRow = (data, col, isAssetClass, colLastField) => {
        const rows = [];
        let rowIndex = 0;
        const indexAlert = [];
        for (const key in this.indexAlertDic) {
            indexAlert.push(this.indexAlertDic[key]);
        }
        const indexAlertSet = new Set([...indexAlert]);
        data.forEach((group) => {
            if (isAssetClass) {
                rows.push(
                    <TableRow
                        col={col.map((ele) => ({
                            title: ele.title,
                            key: ele.title,
                            tdCssWrapper: ele.tdCssWrapper,
                        }))}
                        data={this.getSubTotalRow(group, col)}
                        index={-1}
                        rowCssWrapper="asset-class-row"
                    />
                );
            }
            group.data.map((selection, index) => {
                selection.Treasured =
                    (this.props.treasuredAssetsProductIds || []).includes(selection.Instrument.ProductId) ||
                    this.state.originTreasureAssets.includes(selection.Instrument.ProductId) ||
                    false;
                rows.push(
                    <TableRow
                        key={rowIndex}
                        data={selection}
                        col={indexAlertSet.has(index) ? colLastField : col.map((ele) => ({
                            title: ele.title,
                            key: ele.key,
                            tdCssWrapper: ele.tdCssWrapper,
                            toogleOptions:ele.toogleOptions,
                            render: (data, row, i) => {
                                if (ele.title === "Protect from auto-disinvestment") {
                                    if (row.Instrument.Type === ProductType.CashProduct) {
                                        return (
                                            <div style={{ display: 'inline-block', padding: '0 10px 0 20px', textAlign: 'center' }}>
                                                <span>N/A</span>
                                            </div>
                                        );
                                    } else if (row.Instrument.Type !== ProductType.Cash) {
                                        return (
                                            <div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
                                                <CheckboxEditor
                                                    cssWrapper={"square-checkbox"}
                                                    onChange={function () {}}
                                                    value={this.props.treasuredAssetsProductIds?.includes(row.Instrument.ProductId)}
                                                    disabled={true}
                                                />
                                            </div>
                                        );
                                    }
                                }
                                return ele.render ? ele.render(data, row, i) : data[ele.key];
                            },
                        }))}
                        index={rowIndex}
                    />
                );
                rowIndex = rowIndex + 1;
            });
        });
        return rows;
    };

    private renderInvestmentDetailPopupModal(): JSX.Element
    {
        const { isShowDetailModal, selectedInvestment } = this.state;

        if (!isShowDetailModal)
        {
            return null;
        }

        if (selectedInvestment.Type === ProductType.CashProduct)
        {
            const cashProduct: DepositProduct = this.state.cashProducts[selectedInvestment.ProductId];
            return (
                <>
                    <DepositDetailsPopupModal
                        showBox={isShowDetailModal}
                        callBack={() => this.setState({ isShowDetailModal: false })}
                        instrumentCode={selectedInvestment?.InstrumentCode}
                        productId={selectedInvestment?.ProductId}
                        issuer={cashProduct?.Issuer}
                        depositType={cashProduct?.DepositProductType}
                        term={cashProduct?.Term}
                        grossRate={cashProduct?.GrossInterestRate}
                        aerRate={cashProduct?.AnnualEquivalentInterestRate}
                        minimumInvestment={cashProduct?.MinimumInvestment}
                        maximumInvestment={cashProduct?.MaximumInvestment}
                        instrumentName={selectedInvestment?.DisplayName}
                    />
                </>
            );
        }

        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        this.setState({ isShowDetailModal: false });
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    }

    render() {
        const props = this.props;
        if (!props.data) {return null;}
        if (props.data.length == 0)
            {return <Alert alertType={AlertType.Warning} message={"No investments have been selected."} />;}

        const instrumentData = Objects.cloneObject(props.data);
        const modelPortfolios = instrumentData.filter((ele) => ele.Instrument.Type == ProductType.TailoredModelPortfolio);

        if (modelPortfolios.length > 5) {
            const sliceModelPortfolios: AllocationTableItem[] = modelPortfolios.slice(5);
            sliceModelPortfolios.map((item, idx) => {
                const deleteIndex = instrumentData.indexOf(item);
                if (deleteIndex > -1) {
                    instrumentData.splice(deleteIndex, 1);
                }
            });
        }
        let _data = [];
        if (props.isAssetClass) {
            const groupData = groupBy("Instrument.AssetClass", instrumentData);
            _data = Object.keys(groupData).map((classCode) => {
                return { classCode: classCode, data: groupData[classCode] };
            });
        } else {
            _data = [{ classCode: "", data: instrumentData }];
        }
        const col = allocationTableColConfig(
            props,
            this.state,
            (investment) => this.onInvestmentSelected(investment)
        ).filter((ele) => ele != null);
        const cssWrapper = classNames("data-table", this.props.cssWrapper);
        const dataTotal = this.getTotalRow(col, instrumentData);
        const errorMsgValMax = "Total allocation can't exceed 100%";
        const colLastField = allocationTableColConfig(
            props,
            this.state,
            (investment) => this.onInvestmentSelected(investment),
            100,
            errorMsgValMax,
            this.allocationLeftDic
        ).filter((ele) => ele != null);
        return (
            <>
                {modelPortfolios.length > 5 && (
                    <Alert alertType={AlertType.Warning} message="A maximum of 5 TPS models can be selected." />
                )}
                <table className={cssWrapper}>
                    <TableHeader col={col} />
                    <tbody>{this.renderTableRow(_data, col, props.isAssetClass, colLastField)}</tbody>
                    <tfoot>
                        <TableRow
                            data={dataTotal}
                            col={col.map((ele) => ({
                                title: ele.title,
                                key: ele.title,
                                render: (data, row, i) => {
                                    if (data == "Total") {return data;}

                                    return (
                                        <span className={data == "100%" ? "text-positive" : "text-text"}>{data}</span>
                                    );
                                },
                            }))}
                            index={-1}
                            rowCssWrapper="total cells-right"
                        />
                    </tfoot>
                </table>
                {this.renderInvestmentDetailPopupModal()}
            </>
        );
    }
}
